import type { QueryClient } from '@tanstack/react-query'

/**
 * Query-key names shared across surfaces.
 *
 * A key is vocabulary between whoever fetches under it and whoever invalidates it, and these five
 * are read from more than one place — a case edit has to reset the todo, inbox and chat panes as
 * well as its own. They live here so no surface has to import another to spell its neighbour's key.
 */
export const listCasesKey = 'listCases'
export const getCaseKey = 'getCase'
export const listPersonTodoKey = 'listProvidersWorkUnitsPeopleTodos'
/**
 * Matches the first element of the generated client's inbox query key
 * (`["listProvidersWorkUnitsInbox", pathParams, queryParams]`), so invalidating on this alone
 * prefix-matches every inbox query regardless of its params.
 */
export const getInboxKey = 'listProvidersWorkUnitsInbox'
// Not exported: the chat surfaces still spell this one inline, and re-exporting a key
// nobody imports only implies a contract that is not held anywhere.
const chatKey = 'chat'

/** Resets every surface a case mutation can change: the case, the person's todos, the inbox, chat. */
export const invalidateCachedCaseData = (client: QueryClient, personId: number | null) => {
  return Promise.all([
    client.invalidateQueries({ queryKey: [listCasesKey, personId] }),
    client.invalidateQueries({ queryKey: [listPersonTodoKey, personId] }),
    client.invalidateQueries({ queryKey: [getCaseKey] }),
    client.invalidateQueries({ queryKey: [getInboxKey] }),
    client.invalidateQueries({ queryKey: [chatKey, personId] }),
  ])
}
